import { getQuizManifestEntryByKey } from "@-/dev.improve.haniverse.assets.slides";
import type { ContentAvailability } from "@-/dev.improve.haniverse.lib.database.shards";
import type { CardContentKind } from "#card-content";

/**
 * The review scheduler and every due count share the same installed-pack coverage.
 *
 * A quiz ships in the app bundle rather than a content pack, so it is available whenever this
 * build still has its key: a quiz since retired (or added by a newer build and synced here) drops
 * out of the queue and the counts together.
 */
export function isCardContentAvailable({
  cardContentKind,
  contentAvailability,
  subjectText,
}: {
  cardContentKind: CardContentKind;
  contentAvailability: ContentAvailability;
  subjectText: string;
}): boolean {
  if (cardContentKind === "quiz") {
    return getQuizManifestEntryByKey(subjectText) !== undefined;
  }
  if (contentAvailability.isOnline) {
    return true;
  }
  return cardContentKind === "grapheme-meaning" || cardContentKind === "grapheme-pronunciation"
    ? contentAvailability.graphemes.has(subjectText)
    : contentAvailability.words.has(subjectText);
}
